<template lang="pug">
	.domains-template-check(v-if="showed")
		.card
			.card-header
				span Template Check
				span.last-checked(v-if="lastChecked") Last checked: {{dayjs(lastChecked).format('HH:mm MMM-DD')}}
			.card-body
				.loading-wrapper(v-show="state === 'loading' || state === 'checking'")
					.icon.fa.fa-spinner.fa-spin
					span {{state === 'checking' ? 'Checking domains against the template' : 'Loading last results'}}
				.error(v-show="state === 'error'")
					span {{error}}
				.results(v-show="state === 'loaded'")
					.summary.empty(v-if="!lastChecked")
						span No check has been run yet. Press "Check now".
					.summary.ok(v-else-if="!results.length")
						i.fa.fa-check
						span All {{checked}} domains match the template
					.summary.warn(v-else)
						span {{results.length}} of {{checked}} domains have issues
					.result(v-for="result in results")
						a.domain(target="_blank" :href="'https://' + result.domain") {{result.domain}}
						ul.issues
							li(v-for="issue in result.issues") {{issue}}
			.card-footer
				button.btn.btn-secondary(type="button" v-on:click="hide()") Close
				button.btn.btn-primary(type="button" :disabled="state === 'checking'" v-on:click="runCheck()") Check now
</template>
<script>
	import Screen 			from './../../mixins/screen';
	import dayjs 			from "dayjs";

	export default {
		name: "DomainsTemplateCheck",
		mixins: [Screen],
		screen: {
			updateOn: [],
			showed: false,
			events: {
				'Domains Template Check Results': function (error, results, checked, lastChecked) {

					if (error) {
						this.state = 'error';
						this.error = error;
						return;
					}

					this.results = results || [];
					this.checked = checked || 0;
					this.lastChecked = lastChecked || null;
					this.state = 'loaded';

				}
			}
		},
		data() {

			this.dayjs = dayjs;

			return {
				state: 'loading',
				error: '',
				results: [],
				checked: 0,
				lastChecked: null
			}
		},
		methods: {
			collectData(action) {

				if (action !== 'show') return;

				this.state = 'loading';
				this.error = '';

				Server.sendToSocket({ GetDomainsTemplateCheck: {} });

			},
			runCheck() {

				this.state = 'checking';
				this.error = '';

				Server.sendToSocket({ CheckDomainsTemplateMatch: {} });

			}
		}
	}
</script>

<style lang="sass">
	.domains-template-check
		position: absolute
		z-index: 2000
		background-color: rgba(0, 0, 0, 0.6)
		display: flex
		align-items: center
		justify-content: center
		width: 100%
		height: 100%

		>.card
			width: 60%
			min-height: 400px
			max-height: 80%

			>.card-header
				display: flex
				align-items: center
				gap: 10px

				>.last-checked
					margin-left: auto
					font-size: 80%
					opacity: 0.7

			>.card-body
				overflow-y: auto

				>.loading-wrapper
					height: 300px
					display: flex
					flex-direction: column
					align-items: center
					justify-content: center
					gap: 10px

					.icon
						font-size: 30px

				>.results

					>.summary
						display: flex
						align-items: center
						gap: 10px
						font-weight: bold
						margin-bottom: 15px

						&.ok
							color: #4dbd74
						&.warn
							color: #f8cb00
						&.empty
							opacity: 0.7

					>.result
						padding: 10px 0
						border-top: 1px solid #e4e7ea

						>.domain
							font-weight: bold

						>.issues
							margin: 5px 0 0 0
							padding-left: 20px

							>li
								color: #ff637b

			>.card-footer
				display: flex
				justify-content: flex-end
				gap: 10px
</style>
